import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import { Video, Heart } from "lucide-react";

// "Mes lives" — tout mon historique de Lives, en cours et passés (GET /users/me/lives).
export default function MyLives() {
  const navigate = useNavigate();
  const { lang } = useApp();
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/users/me/lives").then(data => setItems(data?.lives || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 640, margin: "0 auto", padding: "20px 20px 40px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
        <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 20, padding: 0 }}>←</button>
        <h1 style={{ fontSize: 20, fontWeight: 800, margin: 0 }}>{t(lang, "side_menu_my_lives")}</h1>
      </div>

      {loading && <div style={{ textAlign: "center", padding: 60, color: "#999" }}>Chargement…</div>}

      {!loading && items.length === 0 && (
        <div style={{ textAlign: "center", padding: "60px 20px", color: "#999" }}>
          <Video size={40} strokeWidth={1.5} color="#ccc" style={{ marginBottom: 12 }} />
          <div style={{ fontSize: 15, fontWeight: 600 }}>{t(lang, "my_lives_empty_title")}</div>
          <div style={{ fontSize: 13, marginTop: 6 }}>{t(lang, "my_lives_empty_body")}</div>
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 }}>
        {items.map(l => (
          <div key={l.id} style={{ position: "relative", aspectRatio: "9/16", borderRadius: 14, overflow: "hidden", backgroundColor: "#111", cursor: "pointer" }}>
            <video src={l.url} style={{ width: "100%", height: "100%", objectFit: "cover" }} muted />
            <div style={{ position: "absolute", bottom: 6, left: 6, display: "flex", alignItems: "center", gap: 4, color: "white", fontSize: 11, fontWeight: 700, textShadow: "0 1px 3px rgba(0,0,0,0.6)" }}>
              <Heart size={12} fill="white" /> {l.likes_count}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
